const myModal = {
    yes: "确定",
    no: "取消"
};
export default myModal;
